"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.off=exports.on=void 0,exports.on=function(e,t){require("../packages/frame-talk-client-pc/index.js").addEventListener(e,t)},exports.off=function(e,t){require("../packages/frame-talk-client-pc/index.js").removeEventListener(e,t)};


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/lib/bridge/h5PcEvent.js
// module id = 1112
// module chunks = 106